const State = {
  jdproductList: [],
  meta: {},
  jdproductMap: {}
}

export default State
